/**
 * Safely pulls the canvas cards off a gate's content input. Only Dashboard and
 * Report content is canvas-based; everything else (Scorecard, Board, Goal)
 * returns an empty array so callers can fall back to a plain loader.
 *
 * Kept defensive (loose input shape, no throwing) because it runs inside
 * loading gates where the content may be partially populated.
 */
const getContentCanvasCards = (contentInput: {
  contentType?: string;
  content?: unknown;
}): CanvasCard.Card[] => {
  const { contentType, content } = contentInput;
  const isCanvasBased = contentType === 'Dashboard' || contentType === 'Report';

  if (
    isCanvasBased &&
    content &&
    typeof content === 'object' &&
    'canvas' in content
  ) {
    const { canvas } = content as {
      canvas?: { cards?: CanvasCard.Card[] };
    };
    return canvas?.cards ?? [];
  }

  return [];
};

export default getContentCanvasCards;
